// extracted by mini-css-extract-plugin
export default {"govBar":"GovBar_govBar__9fB1j","container":"GovBar_container__5OvRh","officialText":"GovBar_officialText__nS3gQ"};